<template>
  <div class="ba-targeting"
      :class="`device--${ device } ${ journeyTargetingOptions.direction }${ disableTransition ? ' connection-strength-changing' : '' }${ nodeReporting ? ' node-reporting' : '' }`"
      :style="{
        '--targeting-grid-width': gridWidth + 'px',
        '--targeting-grid-box-width': listWidth - (isMoreButtonVisible ? 220 : 420) + 'px',
        '--targeting-grid-line-width': Math.min(3, 1 / paneScale) + 'px',
        '--targeting-content-start-x': targetingContentStartX + 'px',
        '--targeting-wrap-size-x': paneWrapSize[0] + 'px',
        '--targeting-extra-padding-x': paneExtraPadding[3] + 'px',
        '--targeting-extra-padding-y': paneExtraPadding[0] + 'px',
        '--targeting-pane-scale': paneScale
      }"
      v-if="journeyOptions">

    <div v-if="nodesDataArray" class="sequence-header-wrap" :class="{ 'no-data': noData }">
      <div class="sequence-header"
          :style="{
            'width': paneVisibleWidth + 'px',
              'transform': `translate3d(${ panePosition[0] }px, 0, 0) scale(${ paneScale })`
          }">
        <div class="sequence-numbers">
          <template v-for="(sequence, sequenceIndex) in new Array(isMoreSeq ? maxDisplayIndex + 2 : maxDisplayIndex + 1)">
            <template v-if="sequenceIndex > 0">
              <span :key="sequenceIndex"
                    class="number"
                    :class="{'focused': focusedGridIndex === sequenceIndex}">
                <span :style="{
                  'transform': `scale(${ Math.min(3, 1 / paneScale) })`
                }">{{ sequenceIndex }}</span>
              </span>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- <div v-else>nodesDataArray{{ nodesDataArray.length }}</div> -->
    <ba-targeting-sequence-controller v-if="nodesDataArray"
                                      :nodesDataArray="nodesDataArray"
                                      :gridWidth="gridWidth"
                                      :paneScale="paneScale"
                                      :paneWrapSize="paneWrapSize"
                                      :panePosition="panePosition"
                                      :paneBounds="paneBounds"
                                      :croppedDisplayableIndex="croppedDisplayableIndex"
                                      :isForwardDirection="isForwardDirection"
                                      @setFocusedGridIndex="setFocusedGridIndex"
                                      @setPanePosition="setPanePosition" />

    <ba-targeting-control v-if="nodesDataArray"
                          :isForwardDirection="isForwardDirection"
                          :paneScale="Math.round(paneScale * 100)"
                          :grouping="grouping"
                          :group="group"
                          :groupItems="displayGroupItems"
                          :connectionStrength="connectionStrength"
                          :visibleOptions="visibleOptions"
                          :numSelectedVisibleOptions="numSelectedVisibleOptions"
                          :noData="noData"
                          :noJourney="noJourney"
                          :useNullity="useNullity"
                          :isCustomNode="isCustomNode"
                          @onPaneScaleChange="onPaneScaleChange"
                          @onPaneScaleFit="onPaneScaleFit"
                          @onChangeGrouping="setGrouping"
                          @onGroupChange="onGroupChange"
                          @onConnectionOptionChange="setConnectionOption"
                          @onConnectionOptionOpen="disableTransition = true"
                          @onConnectionOptionClose="disableTransition = false"
                          @onVisibleOptionChange="setVisibleOption"
                          @onDownloadExcel="onDownloadExcel"
                          @useNullity="onNullityOnOff" />
    <div v-if="nodesDataArray" ref="paneWrap" class="pane-wrap">
      <div ref="pane" class="pane" :class="{'no-data': noData}"
          :style="{
            'transform': `translate3d(${ panePosition[0] }px, ${ panePosition[1] }px, 0) scale(${ paneScale })`
          }">
        <ba-targeting-list :isForwardDirection="isForwardDirection"
                          :nodesData="nodesData"
                          :nodesDataArray="nodesDataArray"
                          :maxDisplayIndex="maxDisplayIndex"
                          :numCroppedDisplayableSequences="numCroppedDisplayableSequences"
                          :numSequencesLimit="numSequencesLimit"
                          :gridWidth="gridWidth"
                          :paneScale="paneScale"
                          :paneWrapSize="paneWrapSize"
                          :paneExtraPadding="paneExtraPadding"
                          :panePosition="panePosition"
                          :isTrackable="isTrackable"
                          :tracking="trackingData"
                          :grouping="grouping"
                          :group="group"
                          :lookupOption="lookupOption"
                          :connectionStrength="connectionStrength"
                          :visibleOptions="visibleOptions"
                          :numSelectedVisibleOptions="numSelectedVisibleOptions"
                          :reportShowing="reportShowing"
                          :nodeReporting="nodeReporting"
                          :focusedGridIndex="focusedGridIndex"
                          :defaultThumbnail="defaultThumbnail"
                          :disableTransition="disableTransition"
                          :isMoreButtonVisible="isMoreButtonVisible"
                          :noData="noData"
                          :useNullity="useNullity"
                          :more-seq="isMoreSeq"
                          :isCustomNode="isCustomNode"
                          @onHeatmap="onHeatmapView"
                          @onLookupOptionChange="onLookupOptionChange"
                          @displayMoreData="displayMoreData"
                          @onNodeListResize="onNodeListResize"
                          @onSwitchDirection="switchDirection"
                          @onSettingButtonClick="displayBookmarkLayer"
                          @onShowReport="showReport"
                          @setBlocker="setBlocker"
                          @get-seq="loadSeqData"
                          @get-rank="loadRankData"
                          @onShowTrackingLayer="showTrackingLayer"
                          @onStopTracking="stopTracking" />
      </div>

      <div class="pane-dimmed" v-if="isDisabled"></div>
    </div>

    <div class="pane-button">
      <button v-if="nodesData"
              type="button"
              class="exit-targeting"
              @click="exitTargeting">
        <i class="icon icon--exit" />
        {{ $t('journey.targeting.returnToJourney') }}
      </button>
    </div>

    <transition name="grouping">
      <grouping class="grouping-pane"
                v-if="grouping && nodesData && !noData"
                :group="group"
                :groupItems="displayGroupItems"
                :domain="''"
                @onGroupChange="onGroupChange" />
    </transition>

<!--    <transition name="fade">-->
<!--      <div class="reliability" v-if="isSampling">-->
<!--        <i class="icon icon&#45;&#45;alarm"></i>-->
<!--        <span v-if="!isSurvey">{{$t('resample.info', {percent: originJourneyData.reliability})}}</span>-->
<!--        <span v-else>{{$t('resample.survey', {percent: domain.samplingRate})}}</span>-->
<!--      </div>-->
<!--    </transition>-->

    <transition v-if="!noData" name="fade">
      <div class="pane-base-info" v-if="nodesData || samplingReliabilityText">
        <div class="sampling-reliability" v-if="samplingReliabilityText">
          <div class="icon-wrap">
            <i class="icon icon--bell-white size-16"></i>
          </div>
          <div class="message">{{ samplingReliabilityText }}</div>
        </div>
        <div class="pane-date" v-if="nodesData">
          {{ $t('journey.basedOn', { date: dataTimeString, timezone: timezone }) }}
        </div>
      </div>
    </transition>

    <transition name="node-report"
                @afterLeave="onNodeReportLeave">
      <div class="node-report" v-if="reportShowing">
        <ba-node-report v-if="reportData._id !== '-1'"
                        :pageData="reportData"
                        :defaultThumbnail="defaultThumbnail"
                        :captureProcessing="captureProcessing"
                        :valueRange="valueRange"
                        :timezoneName="domain.timezoneName"
                        :group="grouping ? group : false"
                        :useNullity="useNullity"
                        :target-node-id="dataOption.targetNodeId"
                        :target-node-redis-key="nodesDataArray[0][0].redisKey"
                        :lookup-option="lookupOption"
                        :isCustomNode="isCustomNode"
                        :isTracking="Boolean(trackingData)"
                        @onHeatmap="onHeatmapView"
                        @onCapture="onCapture" />
        <ba-node-report-etc v-else
                            :pageData="reportData" />
        <button class="close-report"
                @click="hideReport">
          Hide Report
        </button>
        <!-- <button class="close-report2"
                @click="hideReport">
          <i class="icon icon--close-arrow-right"></i>
        </button> -->
      </div>
    </transition>

    <div v-if="partiallyLoading || reportShowing || paneBlocked"
        class="blocker"
        @click="onBlockerClick" />

    <dimmed v-if="noTargetingData">
      <alert :title="$t('journey.targeting.noTargetingPage.title')"
            :description="$t('journey.targeting.noTargetingPage.description')"
            :submit="$t('common.confirm')"
            @onSubmit="noTargetingData = false" />
    </dimmed>

    <transition name="fade">
      <dimmed v-if="trackingLayerShowing">
        <ba-tracking-layer :nodeData="trackingNodeData" @close="trackingLayerShowing=false" @setTracking="setTracking" />
      </dimmed>
    </transition>

    <transition name="fade">
      <div class="partially-loading" v-if="partiallyLoading">
        <ba-loading :applyBackground="true"
                    :showLoadingText="true" />
      </div>
    </transition>

    <dimmed v-if="capturingPage">
      <ba-capture :pageData="capturingPage"
                  :capturingDevice="capturingDevice"
                  :wholeCaptureProcessing="wholeCaptureProcessing"
                  @onWholeCaptureProcessingChange="wholeCaptureProcessing = $event"
                  @onCaptureProcessing="onCaptureProcessing($event)"
                  @onCloseLayer="capturingPage = null" />
    </dimmed>

    <dimmed v-if="movingGroup">
      <alert :title="$t('group.alert.enter.title')"
            :description="$t('group.alert.enter.description')"
            :cancel="$t('common.cancel')"
            :submit="$t('common.confirm')"
            @onSubmit="onSettingGroup"
            @onCancel="movingGroup = false" />
    </dimmed>

    <dimmed v-if="isHeatmapView">
      <HeatMap
          :report="'target'"
          :pageData="pageDataForHeatmap"
          :seq-direction="journeyTargetingOptions.direction"
          @setHeatMapView="isHeatmapView = $event; heatmapParams=null"
          :heatmapParams="heatmapParams"
          @changeHeatmapParams="heatmapParams = $event"
          :wholeCaptureProcessing="wholeHeatmapCaptureProcessing"
          @onTargetRefresh="onTargetRefresh"
          @onWholeCaptureProcessingChange="wholeHeatmapCaptureProcessing = $event"/>
    </dimmed>
    <dimmed v-if="moreRankLoading || moreSeqLoading">
      <ba-loading :applyBackground="true"
                    :showLoadingText="true" />
    </dimmed>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { format } from 'date-fns'

import {
  getS3Url,
  getS3CaptureDatetime,
  simpleUrl,
  calculateLogDateTime,
  getOffset,
  getDomainForView, parseJwt
} from '@/libs/utils'
import { EventBus } from '@/libs/event-bus'
import { getData, getSeqData, getRankData } from '@/api/targeting'
import { checkCaptureExist } from '@/api/capture'
import { getGroupList } from '@/api/group'
import { getReliabilityData } from '@/api/journey'
import Excel from '@/libs/excel-export'

import Alert from '@/components/ui/Alert'
import Dimmed from '@/components/ui/Dimmed'
import BaLoading from '@/components/ui/ba/Loading'
import AppDialog from '@/components/ui/AppDialog.vue'
import BaTargetingSequenceController from '@/components/targeting/SequenceController'
import BaTargetingControl from '@/components/targeting/PaneControl'
import BaTargetingList from '@/components/targeting/NodeList'
import BaNodeReport from '@/components/journey/NodeReport'
import BaTrackingLayer from '@/components/journey/TrackingLayer'

import BaCapture from '@/components/journey/Capture'
import Grouping from '@/components/journey/Grouping'
import axios from 'axios'
import HeatMap from '@/components/journey/heatmap/HeatMap.vue'
import { create } from 'vue-modal-dialogs'
import { normalizeHeatmapData } from '@/libs/heatmap-data-normalizer'
import { checkCapture } from '@/api/heatmap'
import { checkSampling } from '@/libs/sampling-helper'
import { getAuthToken } from '@/libs/auth-helper'

const wheelEventName = 'onwheel' in document ? 'wheel' : 'DOMMouseScroll' in document ? 'DOMMouseScroll' : 'mousewheel'
const CancelToken = axios.CancelToken
const openDialog = create(AppDialog)

export default {
  name: 'BaTargeting',
  components: {
    HeatMap,
    Alert,
    Dimmed,
    BaLoading,
    BaTargetingSequenceController,
    BaTargetingControl,
    BaTargetingList,
    BaTrackingLayer,
    BaNodeReport,
    Grouping,
    BaCapture
  },
  data () {
    return {
      isHeatmapView: false,
      heatmapParams: null,
      pageDataForHeatmap: null,
      wholeHeatmapCaptureProcessing: [],
      heatmapCaptureProcessingTimer: null,
      wholeHeatmapCaptureProcessingTimer: null,

      isDisabled: false,
      partiallyLoading: false,

      movingGroup: false,

      noData: false,
      noJourney: false,
      noTargetingData: false,

      nodesData: null,
      nodesDataArray: null,

      numSequencesLimit: 7,
      numTotalDataSequences: 0,
      numCroppedDisplayableSequences: 0,

      currentDisplayIndex: 0,
      croppedDisplayableIndex: 0,
      focusedGridIndex: -1,

      gridWidth: 200,

      paneScale: 1,
      panePosition: [0, 0],
      paneWrapSize: [0, 0],
      panePadding: [0, 0, 0, 0],
      paneBounds: [0, 0, 0, 0],
      paneVisibleWidth: 0,

      paneBlocked: false,

      grouping: false,
      group: '1',
      groupItems: {},

      nodeReporting: false,
      reportShowing: false,
      reportData: null,

      defaultThumbnail: null,
      capturingPage: null,
      capturingDevice: null,
      captureProcessing: null,
      captureProcessingTimer: null,

      trackingData: null,
      trackingLayerShowing: false,
      trackingNodeData: null,

      lookupOption: 'reaching',

      connectionStrength: 100,

      valueRange: {
        dropOff: [],
        sessionTime: [],
        repeat: [],
        nullity: []
      },
      visibleOptions: {
        session: true,
        dropOff: true,
        nullity: false,
        refresh: true,
        duration: true
      },
      numSelectedVisibleOptions: 0,

      disableTransition: false,
      useNullity: false,
      isChangeSwitch: false,
      wholeCaptureProcessing: [],
      isMoreRank: false,
      isMoreSeq: false,
      moreSeqLoading: false,
      moreRankLoading: false,
      scalingFactor: 0,
      samplingReliabilityText: null
    }
  },
  computed: {
    ...mapState([
      'journeyPeriod',
      'journeyOptions',
      'journeyTargetingOptions',
      'gnbMinimized',
      'apiCancelSource',
      'domain',
      'originJourneyData',
      'isSampling',
      'basicInfo',
      'aiReportData'
    ]),
    isCustomNode () {
      return this.journeyOptions.isCustomNode
    },
    isSurvey () {
      return this.journeyOptions.survey
    },
    isTrackable () {
      const customUserId = this.domain.beuCustomUserId
      return customUserId && customUserId.length > 0
    },
    timezone () {
      return getOffset(this.domain.timezoneName)
    },
    device () {
      return this.journeyOptions.device
    },
    trackingDataOption () {
      if (!this.isTrackable) return {}
      if (!this.trackingData) return { isMemberDisplayed: true }

      const { type, isAllSelected, excludedMembers = [], selectedMembers = [], memberCacheKey, sessionCacheKey } = this.trackingData
      const data = {
        isMemberDisplayed: true
      }

      if (type === 'member') {
        data.memberCacheKey = memberCacheKey
        data.isAllMemberSelected = false
        data.excludedMembers = excludedMembers.map(item => item.id)
        data.selectedMembers = isAllSelected ? [] : selectedMembers.map(item => item.id)
      } else {
        data.isAllNonMemberSelected = isAllSelected
        data.sessionCacheKey = sessionCacheKey
      }

      return data
    },
    dataOption () {
      return {
        device: this.journeyOptions.device,
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end,
        sid: this.journeyOptions.sid,
        subSid: this.journeyOptions.subSid,
        firstPathname: this.journeyOptions.firstPath,
        serviceType: 'ba',
        matchType: this.journeyOptions.matchType,
        exist: this.journeyOptions.exist,
        refer: this.journeyOptions.refer,
        aiRefererIds: this.journeyOptions.aiRefererIds,
        utm: this.journeyOptions.utm,
        survey: this.journeyOptions.survey,
        targetNodeId: this.journeyOptions.isCustomNode ? this.journeyTargetingOptions.targetNodeKey : this.journeyTargetingOptions.gUrlId,
        isCustomNode: this.journeyOptions.isCustomNode,
        targetNodeKey: this.journeyOptions.isCustomNode || this.journeyOptions.matchType === 'exact' ? this.journeyTargetingOptions.targetNodeKey : null,
        startFromHead: this.lookupOption === 'landing',
        maxSeq: this.journeyTargetingOptions.maxSeq || null,
        ...this.trackingDataOption
      }
    },
    sid () {
      return this.$route.query.sid
    },
    isForwardDirection () {
      return this.journeyTargetingOptions && this.journeyTargetingOptions.direction === 'forward'
    },
    paneExtraPadding () {
      const x = Math.round(this.paneWrapSize[0] * 3)
      const y = Math.round(this.paneWrapSize[1] * 3)
      return [y, x, y, x]
    },
    maxDisplayIndex () {
      return Math.min(this.currentDisplayIndex, this.croppedDisplayableIndex)
    },
    listWidth () {
      return (this.noData ? 0 : Math.max(1, this.maxDisplayIndex) * this.gridWidth) + 425
    },
    isMoreButtonVisible () {
      // return !this.noData && (this.numSequencesLimit <= this.maxDisplayIndex || this.numCroppedDisplayableSequences - 1 > this.maxDisplayIndex)
      return this.isMoreRank || this.isMoreSeq
    },
    targetingContentStartX () {
      return this.paneExtraPadding[3] + Math.max(0, (this.paneWrapSize[0] - (this.listWidth + 164 * 2)) / 2) - (this.isMoreSeq ? 100 : 0)
    },
    dataTimeString () {
      if (this.nodesData && this.domain) {
        // const loadedAt = this.nodesData.loadedAt
        const loadedAt = calculateLogDateTime(this.domain)
        const formatText = this.$t('journey.basedOnFormat')
        return format(loadedAt, formatText)
      } else {
        return ''
      }
    },
    displayGroupItems () {
      const items = {}
      for (const [groupId, groupName] of Object.entries(this.groupItems)) {
        items[groupId] = groupName === 'AUTO' ? this.$t('group.automatic') : groupName
      }
      return items
    },
    moreButtonY () {
      return (-(this.panePosition[1] + this.paneExtraPadding[0]) + this.paneExtraPadding[0] + this.paneWrapSize[1] / 2) * (1 / this.paneScale)
    }
  },
  watch: {
    gnbMinimized () {
      setTimeout(this.onResize, 500)
    },
    journeyTargetingOptions () {
      this.loadPaneData()
    },
    lookupOption () {
      this.setTargetStartFromHead(this.lookupOption === 'landing')
      if (this.isForwardDirection) {
        this.loadPaneData()
      }
    },
    trackingData: {
      handler (newValue) {
        EventBus.$emit('tracking-state', newValue !== null)
      },
      immediate: true
    }
  },
  mounted () {
    this.journeyTargetingOptions.pageFrom === 'journey' && this.loadData()
    this.countSelectedVisibleOptions()

    EventBus.$on('paneDisabled', (value) => {
      this.isDisabled = value
    })

    EventBus.$onSticky('loadPaneData', () => {
      this.loadPaneData()
      this.getReliability()
      EventBus.$clearSticky('loadPaneData')
    })

    EventBus.$onSticky('loadPaneNoData', (value) => {
      this.onLoadData({
        'nodeMap': {},
        'seqMap': {}
      })
      EventBus.$clearSticky('loadPaneNoData')
    })

    EventBus.$on('journeyOptionChange', () => {
      this.trackingData = null
    })

    EventBus.$on('updateBookmark', (updatedKey, value) => {
      const nodeData = this.nodesData.nodeMap[updatedKey]
      if (nodeData) {
        this.$set(nodeData, 'bookmark', value)
      }
    })

    EventBus.$on('updateBaApply', (value) => {
      const gUrlId = value.gUrlId
      const nodeData = this.nodesData.nodeMap[gUrlId]
      if (nodeData) {
        this.$set(nodeData, 'baApply', value)
      }
      if (this.reportData) {
        this.$set(this.reportData, 'baApply', value)
      }
    })

    EventBus.$on('settingGroup', (value = true) => {
      this.movingGroup = value
    })

    clearInterval(this.captureProcessingTimer)
    this.captureProcessingTimer = setInterval(() => {
      const data = this.captureProcessing
      if (data) {
        checkCaptureExist(data.sid, data.urlId, data.matchType, data.url)
          .then(result => {
            if (result.imagePath && result.imagePath[this.capturingDevice]) {
              const identifier = this.journeyOptions.matchType === 'exact' ? data._id : data.urlId
              const nodeInfo = this.nodesData.nodeMap[identifier]
              if (nodeInfo) {
                const deviceCapture = result.imagePath[this.capturingDevice]
                const newCaptureDate = getS3CaptureDatetime(deviceCapture) || result.captureDate

                if (deviceCapture && nodeInfo.captureDate !== newCaptureDate) {
                  if (nodeInfo.gUrlId === data.urlId) {
                    this.captureProcessing = null
                    nodeInfo.captureDate = this.reportData.captureDate = result.captureDate
                    this.reportData.realCaptureDate[this.capturingDevice] = newCaptureDate
                    nodeInfo.imagePath[this.capturingDevice] = this.reportData.imagePath[this.capturingDevice] = result.imagePath[this.capturingDevice]
                    nodeInfo.realCaptureUrl[this.capturingDevice] = this.reportData.realCaptureUrl[this.capturingDevice] = result.realCaptureUrl[this.capturingDevice]

                    const currentThumbnail = getThumbnailPath(result, this.device)
                    if (currentThumbnail) {
                      nodeInfo.thumbnail = this.reportData.thumbnail = getS3Url(currentThumbnail)
                    }

                    this.generateNodeDataArray()
                  }
                }
              }
            }
          })
          .catch(() => {
            this.captureProcessing = null
          })
      }
    }, 5000)

    this.wholeHeatmapCaptureProcessingTimer = setInterval(() => {
      const data = this.wholeHeatmapCaptureProcessing
      if (data.length !== 0) {
        for (let index in data) {
          const params = `/${data[index].requestId}/${data[index].uuid}`
          checkCapture(params, true).then(task => {
            const tasks = task.data
            if (!tasks.length) {
              throw new Error('no tasks')
            }
            let successCount = 0
            let failedCount = 0
            for (const item of tasks) {
              if (item.statusCode === 10) {
                successCount++
              } else if (item.statusCode < 0) {
                failedCount++
              }
              if (successCount + failedCount === tasks.length) {
                if (successCount === 0) {
                  this.wholeHeatmapCaptureProcessing[index].state = 'failed'
                  let failedCheck = true
                  this.wholeHeatmapCaptureProcessing.forEach(item => {
                    if (item.state !== 'failed') {
                      failedCheck = false
                    }
                  })
                  if (failedCheck) {
                    this.wholeHeatmapCaptureProcessing[index].state = 'failed'
                  }
                } else {
                  this.wholeHeatmapCaptureProcessing[index].state = 'success'
                  let successCheck = true
                  this.wholeHeatmapCaptureProcessing.forEach(item => {
                    if (item.state !== 'success') {
                      successCheck = false
                    }
                  })
                  if (successCheck) {
                    this.wholeHeatmapCaptureProcessing[index].state = 'success'
                  }
                }
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    }, 5000)

    this.loadGroupList()

    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    clearInterval(this.captureProcessingTimer)
    clearInterval(this.heatmapCaptureProcessingTimer)
    this.captureProcessingTimer = null
    this.wholeHeatmapCaptureProcessingTimer = null
    EventBus.$off('loadPaneData')
    // EventBus.$off('loadPaneNoData')
    EventBus.$off('updateBookmark')
    EventBus.$off('settingGroup')
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations([
      'setJourneyTargetingOptions',
      'setBookmarkListLayerOptions',
      'setJourneyOptions',
      'setApiCancelSource',
      'setOriginJourneyData',
      'setTargetStartFromHead',
      'setAIReportData'
    ]),
    resetAIReportData () {
      setTimeout(() => {
        this.setAIReportData(null)
        if (this.$route.query.aiReportId) {
          const newQuery = { ...this.$route.query }
          delete newQuery.aiReportId
          delete newQuery.aiReportTreeId
          this.$router.replace({ query: newQuery })
        }
      }, 1000)
    },
    onTargetRefresh () {
      this.isHeatmapView = false
      this.reportShowing = null
      this.loadPaneData(true)
    },
    onHeatmapView (pageData) {
      if (pageData) {
        pageData = normalizeHeatmapData(pageData)
      }
      const pageDataForHeatmap = pageData

      this.pageDataForHeatmap = pageDataForHeatmap

      if (!this.isHeatmapView) {
        this.heatmapParams = null

        this.heatmapParams = {
          serviceType: 'ba',
          // ...this.journeyOptions,
          // ...this.journeyPeriod,
          // ...this.reportShowing,
          gUrlId: pageDataForHeatmap.gUrlId,
          parentSeq: -1,
          parentSid: pageDataForHeatmap.baApply.parentSid,
          sid: pageDataForHeatmap.baApply.sid,
          redisKey: pageDataForHeatmap.redisKey,
          targetNodeId: this.journeyTargetingOptions.targetNodeId || this.journeyTargetingOptions.gUrlId,
          scalingFactor: this.scalingFactor,
          url: pageDataForHeatmap.url
        }
        // console.log('heatmap params : ', JSON.stringify(this.heatmapParams))

        this.isHeatmapView = true
      }
    },
    onNullityOnOff (value) {
      if (value) {
        this.visibleOptions['nullity'] = false
        this.useNullity = true
      } else {
        delete this.visibleOptions['nullity']
        this.useNullity = false
      }
    },
    getReliability () {
      if (!(this.domain.preSamplingRate < 100 || this.domain.postSamplingRate < 100)) return

      const requestData = {
        sid: this.journeyOptions.sid,
        matchType: this.journeyOptions.matchType,
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end
      }

      if (new Date(this.journeyPeriod.start).getTime() >= new Date(this.domain.samplingChangeDate).getTime()) {
        getReliabilityData(requestData).then(res => {
          const result = this.$t('common.samplingReliability.reliabilityRateText', { data: res.reliabilityPercentage.toFixed(1) })
          this.samplingReliabilityText = result
        })
      } else {
        this.samplingReliabilityText = this.$t('common.samplingReliability.reliabilityRateException')
      }
    },
    loadSeqData () {
      this.moreSeqLoading = true
      let requestData = {
        targetNodeId: this.dataOption.targetNodeId,
        device: this.dataOption.device,
        start: this.dataOption.start,
        end: this.dataOption.end,
        exist: this.dataOption.exist,
        matchType: this.dataOption.matchType,
        refer: this.dataOption.refer,
        aiRefererIds: this.dataOption.aiRefererIds,
        sid: this.dataOption.sid,
        survey: this.dataOption.survey,
        utm: this.dataOption.utm,
        serviceType: this.dataOption.serviceType,
        startFromHead: false,
        right: false,
        scalingFactor: this.scalingFactor,
        isCustomNode: this.dataOption.isCustomNode,
        targetNodeKey: this.dataOption.targetNodeKey,
        isMemberDisplayed: this.isTrackable
      }

      if (this.isForwardDirection) {
        requestData.right = true
      }
      if (this.lookupOption === 'landing') {
        requestData.startFromHead = true
      }
      requestData.targetSeq = this.nodesDataArray.length
      requestData.tempDFKey = this.nodesDataArray[0][0].redisKey
      const lastSeq = this.nodesDataArray.length - 1
      let lastSeqData = this.nodesDataArray[lastSeq].map(item => {
        return {
          gUrlId: item._id,
          currHash: item._hash,
          redisKey: item.redisKey,
          currPath: item.currPath,
          nodeKey: item._id
        }
      })
      requestData.nodeData = lastSeqData
      // dataOption.nodeData = this.nodesData.seqMap[lastObj[0]
      getSeqData(requestData).then(result => {
        this.isMoreSeq = result.isMoreSeq
        this.nodesData.isMoreSeq = result.isMoreSeq
        const moreData = result.seqMap[requestData.targetSeq] && Object.keys(result.seqMap[requestData.targetSeq]).length > 0
        if (moreData) {
          this.nodesData.nodeMap = { ...this.nodesData.nodeMap, ...result.nodeMap }
          this.nodesData.seqMap = { ...this.nodesData.seqMap, ...result.seqMap }
          this.onLoadData(this.nodesData)
        }
        this.moreSeqLoading = false
      })
    },
    loadRankData () {
      this.moreRankLoading = true
      let requestData = {
        targetNodeId: this.dataOption.targetNodeId,
        device: this.dataOption.device,
        start: this.dataOption.start,
        end: this.dataOption.end,
        exist: this.dataOption.exist,
        matchType: this.dataOption.matchType,
        refer: this.dataOption.refer,
        aiRefererIds: this.dataOption.aiRefererIds,
        sid: this.dataOption.sid,
        survey: this.dataOption.survey,
        utm: this.dataOption.utm,
        serviceType: this.dataOption.serviceType,
        startFromHead: false,
        right: false,
        scalingFactor: this.scalingFactor,
        isCustomNode: this.dataOption.isCustomNode,
        targetNodeKey: this.dataOption.targetNodeKey,
        isMemberDisplayed: this.isTrackable
      }
      requestData.maxSeq = this.nodesDataArray.length - 1
      requestData.targetRank = this.nodesDataArray[1].length
      requestData.tempDFKey = this.nodesDataArray[0][0].redisKey
      if (this.isForwardDirection) {
        requestData.right = true
      }
      if (this.lookupOption === 'landing') {
        requestData.startFromHead = true
      }
      getRankData(requestData).then(result => {
        const nodesData = { ...this.nodesData }
        nodesData.nodeMap = { ...this.nodesData.nodeMap, ...result.nodeMap }
        this.isMoreRank = result.isMoreSeq
        nodesData.isMoreSeq = result.isMoreSeq
        for (let seq in result.seqMap) {
          for (let node in result.seqMap[seq]) {
            if (nodesData.seqMap[seq] && nodesData.seqMap[seq][node]) {
              nodesData.seqMap[seq][node].data = { ...nodesData.seqMap[seq][node].data, ...result.seqMap[seq][node].data }
            } else {
              if (!nodesData.seqMap[seq]) {
                nodesData.seqMap[seq] = {}
              }
              if (!nodesData.seqMap[seq][node]) {
                nodesData.seqMap[seq][node] = {}
              }
              nodesData.seqMap[seq][node] = result.seqMap[seq][node]
            }
          }
        }
        if (!result.isMoreRank) {
          nodesData.isMoreRank = false
          delete nodesData.nodeMap['999999999']
          delete nodesData.seqMap['1']['999999999']
        }
        return nodesData
      }).then((nodesData) => {
        this.onLoadData(nodesData)
        this.moreRankLoading = false
        // this.panePosition = [this.panePosition[0], this.panePosition[1] - 200]
        this.panePosition = [this.panePosition[0], -Infinity]
      })
    },
    loadPaneData (force) {
      this.nodesDataArray = null
      this.panePosition = [0, 0]
      this.reportShowing = false
      this.isMoreSeq = false
      if (!this.isForwardDirection) {
        this.lookupOption = 'reaching'
      }
      this.loadData(force)
    },
    loadData (force) {
      const authToken = getAuthToken()
      let tokenData = null
      if (authToken) {
        tokenData = parseJwt(authToken)
        if (tokenData && tokenData.identity) {
          if (tokenData.identity.is_demo) {
            if (this.$route.query.targetNodeId) {
              const newQuery = { ...this.$route.query }
              delete newQuery.targetNodeId
              this.$router.replace({ query: newQuery })
              return
            }
          }
        }
      }

      EventBus.$emit('paneDisabled', false)
      EventBus.$emit('onLoading', true)

      if (force) {
        this._dataCacheMap = null
        this.lookupOption = 'reaching'

        this.setJourneyTargetingOptions({
          ...this.journeyTargetingOptions,
          direction: 'backward'
        })
      }

      const dataOption = { ...this.dataOption }
      if (this.isForwardDirection) {
        dataOption.right = true
      }
      if (this.lookupOption === 'landing') {
        dataOption.startFromHead = true
      }
      const cacheKey = JSON.stringify(dataOption).replace(/['"]/g, '')

      if (!this._dataCacheMap) {
        this._dataCacheMap = {}
      }

      if (this._dataCacheMap[cacheKey]) {
        setTimeout(() => {
          this.onLoadData(JSON.parse(this._dataCacheMap[cacheKey]))
        }, 600)
      } else {
        this.setApiCancelSource(CancelToken.source())
        getData(dataOption, true, this.apiCancelSource.token)
          .then(response => {
            this._dataCacheMap[cacheKey] = JSON.stringify(response)
            response.loadedAt = new Date()
            this.scalingFactor = response.scalingFactor
            this.onLoadData(response)
            this.resetAIReportData()
          })
          .catch((e) => {
            if (this.nodesData && this.nodesData.loadedAt) {
              this.setJourneyTargetingOptions({
                ...this.journeyTargetingOptions,
                direction: this.isForwardDirection ? 'backward' : this.journeyTargetingOptions.direction
              })

              this.onLoadData(this.nodesData, true)
            }
            EventBus.$emit('onError')
            this.apiLoading = false
          })
      }
    },
    async onLoadData (data, isCancel, payload) {
      const gUrlId = this.isCustomNode ? this.journeyTargetingOptions.targetNodeKey : this.journeyTargetingOptions.gUrlId
      if (this.isSampling && !this.isSurvey) {
        const samplingInfo = await checkSampling(this.domain, this.basicInfo, this.originJourneyData)
        // console.log(checkSampling(this.domain, this.basicInfo))
        if (samplingInfo) {
          this.setOriginJourneyData(samplingInfo)
        } else {
          EventBus.$emitSticky('loadPaneNoData', true, true)
        }
      }

      this.isMoreSeq = this.isMoreSeq || data.isMoreSeq

      this.isMoreRank = data.isMoreRank
      if (this.isMoreRank) {
        const targetHash = Object.keys(data.seqMap['1'])[0]
        const targetFrom = Object.values(data.seqMap['1'][targetHash]['data'])[0]
        data.nodeMap['999999999'] = { ...data.nodeMap[targetHash] }
        data.seqMap['1']['999999999'] = {
          ...data.seqMap['1'][targetHash],
          'data': {
            'fake-hash': {
              'from': targetFrom['from'],
              'cnt': 0,
              'sessTime': 0,
              'sessCnt': 0,
              'dropCnt': 0,
              'reloadCnt': 0,
              'rollCnt': 0
            }
          }
        }
      }
      this.nodesData = data

      this.nodesData.loadedAt = new Date()

      // this.numTotalDataSequences = Math.min(this.numSequencesLimit, Math.max.apply(null, Object.keys(data.seqMap) - 1))
      this.numTotalDataSequences = Object.keys(data.seqMap).length

      // this.currentDisplayIndex = 1
      this.currentDisplayIndex = Object.keys(data.seqMap).length
      // this.numSequencesLimit = this.currentDisplayIndex + 1
      this.croppedDisplayableIndex = 0

      this.connectionStrength = 100

      this.paneScale = 1

      this.setJourneyOptions({
        ...this.journeyOptions,
        seq: this.isForwardDirection ? Object.keys(data.seqMap).length - 1 : Object.keys(data.seqMap).length
      })

      if (!this.nodesData.seqMap['0']) {
        this.nodesData.seqMap = {
          '0': {}
        }
        this.nodesData.seqMap['0'][gUrlId] = {
          'data': {
            'fake-hash': {
              'from': {},
              'cnt': 0,
              'sessTime': 0,
              'sessCnt': 0,
              'dropCnt': 0,
              'reloadCnt': 0,
              'rollCnt': 0,
              'gUrlId': gUrlId
            }
          }
        }
        this.numTotalDataSequences = 1

        this.noJourney = true
      } else {
        this.noJourney = false
      }
      if (!data.nodeMap) {
        data.nodeMap = {}
      }
      if (!data.nodeMap[gUrlId] && this.journeyTargetingOptions.nodeData) {
        data.nodeMap[gUrlId] = this.journeyTargetingOptions.nodeData
      }

      this.generateNodeDataArray()
      this.calculateDisplayableNodes()

      setTimeout(() => {
        EventBus.$emit('onLoading', false)
      }, this.noJourney ? 500 : 0)

      const currentNodeId = this.nodesDataArray[0][0]._id || (payload ? payload.targetNodeId : null)
      const nodeMap = this.nodesData.nodeMap
      const journeyOptionsDomain = this.journeyOptions.domain
      const journeyOptionsDevice = this.journeyOptions.device
      const journeyOptionsMatchType = this.journeyOptions.matchType
      const a = document.createElement('a')

      let forceDisplaySubdomain = false
      for (let key in nodeMap) {
        if (nodeMap[key]) {
          a.href = nodeMap[key].url
          if (a.hostname !== journeyOptionsDomain) {
            const subDomain = a.hostname.replace('.' + journeyOptionsDomain, '')
            if (subDomain.split('.')[0] !== 'www') {
              forceDisplaySubdomain = true
              break
            }
          }
        }
      }

      for (let key in nodeMap) {
        let nodeInfo = nodeMap[key]
        if (nodeInfo) {
          nodeInfo.key = [
            this.journeyOptions.matchType.substr(0, 1),
            this.journeyOptions.sid,
            '|', key
          ].join('')
          nodeInfo.gUrlId = isNaN(key) ? key : parseInt(key)
          if (nodeInfo.url) {
            nodeInfo.linkUrl = simpleUrl(nodeInfo.url, journeyOptionsMatchType)

            a.href = nodeInfo.url

            nodeInfo.linkHost = getDomainForView(a.host)

            nodeInfo.linkPath = a.pathname
            if (journeyOptionsMatchType === 'exact') {
              const pathStartIdx = a.href.indexOf(a.host) + a.host.length
              nodeInfo.linkPath = a.href.slice(pathStartIdx)
            }
            nodeInfo.linkPath = decodeURI(nodeInfo.linkPath)
            nodeInfo.linkProtocol = a.protocol

            if (a.hostname !== journeyOptionsDomain) {
              let subDomain = a.hostname.replace('.' + journeyOptionsDomain, '')
              if (forceDisplaySubdomain || subDomain.split('.')[0] !== 'www') {
                nodeInfo.subDomain = subDomain
              }
            }
          }

          const currentThumbnail = getThumbnailPath(nodeInfo, journeyOptionsDevice)
          if (currentThumbnail) {
            nodeInfo.thumbnail = getS3Url(currentThumbnail)

            if (!this.defaultThumbnail && nodeInfo.thumbnail) {
              this.defaultThumbnail = nodeInfo.thumbnail
            }
          }

          nodeInfo.sameAsCurrent = (isNaN(key) ? key : parseInt(key)) === currentNodeId
          nodeInfo = normalizeHeatmapData(nodeInfo)
        }
      }

      this.countSelectedVisibleOptions()

      this.$nextTick(() => {
        this.unsetPaneDraggable()
        this.setPaneDraggable()

        requestAnimationFrame(() => {
          if (!this.isMoreSeq && !this.isMoreRank) {
            this.panePosition = [this.isForwardDirection ? 0 : -Infinity, 0]
          }
          this.setPaneOverflowPosition(true)
        })
        this.onResize()
      })
    },
    displayMoreData () {
      let prevDisplayIndex = this.currentDisplayIndex

      this.currentDisplayIndex += 1
      this.calculateDisplayableNodes()

      if (!this.isForwardDirection) {
        const lengthGap = this.currentDisplayIndex - prevDisplayIndex
        this.setPanePositionWithoutTransition(this.panePosition[0] - this.gridWidth * lengthGap, this.panePosition[1])
      }

      setTimeout(() => {
        this.setPaneMinPosition()
        this.panePosition = [this.paneBounds[this.isForwardDirection ? 2 : 0], this.panePosition[1]]
      }, 50)
    },
    calculateDisplayableNodes () {
      const dataArray = this.nodesDataArray
      const maxSequences = this.numTotalDataSequences

      let numCroppedDisplayableSequences = 0
      for (let sequenceIndex = 0; sequenceIndex < maxSequences; sequenceIndex++) {
        dataArray[sequenceIndex].forEach((nodeData, nodeIndex) => {
          nodeData._height = 0
          nodeData._display = (!nodeData._parent || nodeData._parent._display) && Math.max(10, this.connectionStrength) >= nodeData._rankRate
          if (nodeData._display) {
            numCroppedDisplayableSequences = Math.max(sequenceIndex + 1, numCroppedDisplayableSequences)
          }
        })
      }
      this.numCroppedDisplayableSequences = numCroppedDisplayableSequences
      let croppedDisplayableIndex = 0
      for (let sequenceIndex = maxSequences - 1; sequenceIndex >= 0; sequenceIndex--) {
        const visible = sequenceIndex <= this.currentDisplayIndex
        dataArray[sequenceIndex].forEach((nodeData) => {
          if (visible && nodeData._display) {
            nodeData._height = nodeData._height || 1
            if (nodeData._parent) {
              nodeData._parent._height += nodeData._height
            }
            if (croppedDisplayableIndex === 0) {
              croppedDisplayableIndex = sequenceIndex
            }
          }
        })
      }
      if (dataArray.length > 1) {
        dataArray[1][0]._height = Math.max(dataArray[1][0]._height, 2)
      }
      this.croppedDisplayableIndex = croppedDisplayableIndex

      for (let sequenceIndex = 0; sequenceIndex < maxSequences; sequenceIndex++) {
        dataArray[sequenceIndex].forEach((nodeData) => {
          nodeData._y = 0
          nodeData._ignore = false
          if (nodeData._parent) {
            nodeData._y += nodeData._parent._y
            const childIndex = nodeData._parent._children.indexOf(nodeData)
            if (childIndex > 0) {
              nodeData._y += sumPrevNodesHeight(nodeData._parent._children, childIndex)
              if (!nodeData._parent._children[childIndex - 1]._display || sequenceIndex > this.currentDisplayIndex) {
                nodeData._ignore = true
              }
            }
          }
        })
      }

      this.setValueRange()
    },
    generateNodeDataArray () {
      const seqMap = this.nodesData.seqMap
      const dataArray = []
      const maxSequences = this.numTotalDataSequences

      let sessionValues = []

      for (let sequenceIndex = 0; sequenceIndex < maxSequences; sequenceIndex++) {
        const sequenceData = seqMap[sequenceIndex]
        if (!dataArray[sequenceIndex]) {
          dataArray[sequenceIndex] = []
        }
        for (let nodeId in sequenceData) {
          let nodeData = sequenceData[nodeId]
          nodeData.baApply = this.nodesData.nodeMap[nodeId] ? (this.nodesData.nodeMap[nodeId].baApply ? this.nodesData.nodeMap[nodeId].baApply : null) : null

          nodeData = normalizeHeatmapData(nodeData)

          if (typeof nodeData === 'object') {
            if (!nodeData.data) {
              nodeData = {
                data: {
                  'fake-hash': nodeData
                }
              }
            }

            for (let hash in nodeData.data) {
              const childData = nodeData.data[hash]
              childData._hash = hash !== 'fake-hash' ? hash : ''
              childData._seq = sequenceIndex
              childData._id = isNaN(nodeId) ? nodeId : parseInt(nodeId)
              childData._children = []
              childData.nullityCnt = childData.rollCnt
              childData.customValue = nodeData.customValue
              childData.customId = nodeData.customId
              childData.customColor = nodeData.customColor
              if (childData.redisKey) {
                nodeData.redisKey = childData.redisKey
              }
              if (!this.isForwardDirection) {
                delete childData.dropCnt
              }
              if (sequenceIndex > 0) {
                const parentNodeIndex = getParentNodeIndex(dataArray[sequenceIndex - 1], childData.from)
                if (parentNodeIndex > -1) {
                  dataArray[sequenceIndex - 1][parentNodeIndex]._children.push(childData)
                  childData._parent = dataArray[sequenceIndex - 1][parentNodeIndex]
                }
              }
              sequenceIndex > 0 && sessionValues.indexOf(childData.sessCnt) < 0 && sessionValues.push(childData.sessCnt)
              dataArray[sequenceIndex].push(childData)
            }
          }
          // nodeData.redisKey = nodeData.data[nodeId].redisKey ? nodeData.data[nodeId].redisKey : null
        }
      }

      sessionValues = sessionValues.sort(sortByValue).reverse()
      const numSessionValues = sessionValues.length

      for (let sequenceIndex = 0; sequenceIndex < maxSequences; sequenceIndex++) {
        dataArray[sequenceIndex].sort(sortByHigherSessCnt)
        dataArray[sequenceIndex].forEach((nodeData) => {
          const rank = sessionValues.indexOf(nodeData.sessCnt)
          nodeData._rankRate = Math.round(rank / numSessionValues * 100)
          nodeData._children && nodeData._children.sort(sortByHigherSessCnt)
        })
      }

      this.nodesDataArray = dataArray
    },
    setValueRange () {
      for (let key in this.valueRange) {
        this.valueRange[key] = []
      }
      this.nodesDataArray.forEach((sequence) => {
        sequence.forEach((nodeData) => {
          if (nodeData._display) {
            nodeData.dropOff = nodeData.dropCnt ? nodeData.dropCnt / nodeData.sessCnt * 100 : 0
            nodeData.repeat = nodeData.reloadCnt ? nodeData.reloadCnt / nodeData.sessCnt * 100 : 0
            nodeData.nullity = nodeData.nullityCnt ? nodeData.nullityCnt / nodeData.sessCnt * 100 : 0
            nodeData.redisKey = nodeData.redisKey ? nodeData.redisKey : null

            if (this.isSampling && !this.isSurvey) {
              nodeData.resampleSessCnt = nodeData.sessCnt / this.originJourneyData.sessionSamplingRate
              nodeData.resampleCnt = nodeData.cnt / this.originJourneyData.sessionSamplingRate
              nodeData.resampleDropCnt = nodeData.dropCnt / this.originJourneyData.sessionSamplingRate
              nodeData.dropOff = nodeData.resampleDropCnt ? nodeData.resampleDropCnt / nodeData.resampleSessCnt * 100 : 0
            }

            this.valueRange.dropOff.push(nodeData.dropOff)
            this.valueRange.sessionTime.push(nodeData.sessTime / 1000)
            this.valueRange.repeat.push(nodeData.repeat)
            this.valueRange.nullity.push(nodeData.nullity)
          }
        })
      })
      for (let key in this.valueRange) {
        this.valueRange[key].sort(sortByValue)
      }
    },

    setConnectionOption (value) {
      this.connectionStrength = value
      this.calculateDisplayableNodes()
    },

    setVisibleOption (name) {
      this.visibleOptions[name] = !this.visibleOptions[name]
      this.countSelectedVisibleOptions()
    },
    countSelectedVisibleOptions () {
      let count = 0
      for (let name in this.visibleOptions) {
        if ((name !== 'dropOff' || (name === 'dropOff' && this.isForwardDirection)) && this.visibleOptions[name] === true) {
          count++
        }
      }
      this.numSelectedVisibleOptions = count
    },
    onLookupOptionChange (item) {
      this.lookupOption = item
    },

    setFocusedGridIndex (index) {
      if (!this.paneBlocked) {
        this.focusedGridIndex = index
      }
    },

    displayBookmarkLayer () {
      this.setBookmarkListLayerOptions({
        gUrlId: this.journeyTargetingOptions.gUrlId
      })
    },
    switchDirection () {
      const direction = this.journeyTargetingOptions.direction === 'forward' ? 'backward' : 'forward'
      this.nodesDataArray = null

      this.setJourneyTargetingOptions({
        ...this.journeyTargetingOptions,
        direction
      })
    },
    exitTargeting () {
      this.setJourneyTargetingOptions(null)
    },

    showReport (sequenceIndex, nodeIndex, highlightedSequenceIndex, highlightedNodeIndex) {
      if (!this.reportShowing) {
        const nodeData = this.nodesDataArray[sequenceIndex][nodeIndex]
        const nodeInfo = this.nodesData.nodeMap[nodeData._id] || {}

        nodeInfo.gUrlId = nodeData.gUrlId
        this.reportShowing = true
        this.nodeReporting = true

        let reportData = {
          isTargeting: true,
          nodeId: isNaN(nodeData._id) ? nodeData._id : parseInt(nodeData._id),
          ...nodeData,
          ...nodeInfo,
          sessTime: nodeData.sessTime / 1000
        }

        reportData = normalizeHeatmapData(reportData)

        reportData.imagePath = reportData.imagePath || {}
        reportData.realCaptureDate = {
          desktop: getS3CaptureDatetime(reportData.imagePath['desktop']) || reportData.captureDate,
          tablet: getS3CaptureDatetime(reportData.imagePath['tablet']) || reportData.captureDate,
          phone: getS3CaptureDatetime(reportData.imagePath['phone']) || reportData.captureDate
        }

        const currentThumbnail = getThumbnailPath(reportData, this.device)
        if (currentThumbnail) {
          reportData.thumbnail = getS3Url(currentThumbnail)
        }

        this.reportData = reportData

        const layout = nodeData._layout
        this._formerPosition = this.panePosition.slice()
        let left = this.isForwardDirection ? layout.x : this.listWidth - layout.x
        let listBgLeft = this.$refs.pane.querySelector('.ba-targeting-list-bg').offsetLeft
        if (!this.isForwardDirection) {
          listBgLeft -= Math.max(0, this.listWidth - this.$refs.pane.querySelector('.ba-targeting-list-bg').offsetWidth)
        }
        left = (listBgLeft + left) * this.paneScale
        let top = (this.paneExtraPadding[0] + layout.y + 112 + (layout.height / 2)) * this.paneScale
        left = -(left - (this.paneWrapSize[0] / 2) + (430 / 2) - (52 / 2))
        top = -(top - (this.paneWrapSize[1] / 2) - (32 / 2))
        this.panePosition = [left, Math.min(0, Math.max(this.paneBounds[3] - this.paneExtraPadding[2] * this.paneScale, top))]
      }
    },
    hideReport () {
      if (this.reportShowing) {
        this.reportShowing = false
        this.panePosition = this._formerPosition
      }
    },
    onNodeReportLeave () {
      this.nodeReporting = false
    },

    onCapture (pageData, device) {
      this.capturingDevice = device
      this.capturingPage = pageData
    },
    onCaptureProcessing (pageKey) {
      this.captureProcessing = pageKey
    },

    loadGroupList () {
      return new Promise(resolve => {
        getGroupList({
          sid: this.sid
        }, true).then(result => {
          this.groupItems = {}
          for (let group of result) {
            if (group.usableStatus !== 'PENDING') {
              this.groupItems[group.groupId] = group.groupName
            }
          }
          resolve()
        })
      })
    },
    setGrouping (value) {
      if (this.grouping !== value) {
        this.grouping = value
      }
      EventBus.$emit('group-state', this.grouping)
    },
    onGroupChange (value) {
      if (this.group !== value) {
        this.group = value
      }
      this.setGrouping(true)
    },
    onSettingGroup () {
      this.movingGroup = false
      this.$router.push({ name: 'group', query: { sid: this.sid } })
    },

    onDownloadExcel () {
      let fileName = this.journeyOptions.domain + '_Journey'
      let excel = new Excel()
      const isSampling = this.domain.preSamplingRate < 100 || this.domain.postSamplingRate < 100
      this.apiLoading = true

      excel.setTargetingInfo(this.nodesData.nodeMap[this.nodesDataArray[0][0]._id], this.isForwardDirection, this.lookupOption === 'landing', this.connectionStrength, isSampling, this.originJourneyData)
        .then(() => {
          excel.setTargetingData(this.nodesDataArray, this.nodesData.nodeMap, this.isForwardDirection, isSampling, this.originJourneyData, this.isMoreSeq, this.isMoreRank)
            .then(() => {
              excel.setTargetingPageInfo(this.nodesDataArray, this.nodesData.nodeMap, this.nodesDataArray[0][0]._id, isSampling, this.originJourneyData)
                .then(() => {
                  excel.download(fileName)
                  this.apiLoading = false
                })
            })
        }).catch(() => {
          this.apiLoading = false
        })
    },

    setPaneDraggable () {
      const paneWrap = this.$refs.paneWrap
      if (paneWrap) {
        paneWrap.addEventListener('mousedown', this.onPointerDown)
        paneWrap.addEventListener('touchstart', this.onPointerDown)
        paneWrap.addEventListener(wheelEventName, this.onWheel, { passive: false })
      }
    },
    unsetPaneDraggable () {
      const paneWrap = this.$refs.paneWrap
      if (paneWrap) {
        paneWrap.removeEventListener('mousedown', this.onPointerDown)
        paneWrap.removeEventListener('touchstart', this.onPointerDown)
        paneWrap.removeEventListener(wheelEventName, this.onWheel, { passive: false })
      }
    },
    onWheel (e) {
      const deltaX = e.deltaX !== undefined ? e.deltaX : e.wheelDeltaX || 0
      const deltaY = e.deltaY !== undefined ? e.deltaY : e.wheelDeltaY !== undefined ? e.wheelDeltaY : e.detail || e.wheelDelta * -1
      this.setPaneMinPosition()
      const left = Math.min(this.paneBounds[0], Math.max(this.paneBounds[2], this.panePosition[0] - deltaX))
      const top = Math.min(this.paneBounds[1], Math.max(this.paneBounds[3], this.panePosition[1] - deltaY))
      cancelAnimationFrame(this._debouncer)
      this._debouncer = requestAnimationFrame(() => {
        this.setPanePositionWithoutTransition(left, top)
      })
      e.preventDefault()
    },
    onPointerDown (e) {
      if (!e.which || e.which === 1) {
        this._downPoint = getEventPoint(e)
        this._downPosition = this.panePosition
        this.setPaneMinPosition()
        this._dragActivated = false
        document.addEventListener('mousemove', this.onPointerMove)
        document.addEventListener('touchmove', this.onPointerMove, { passive: false })
        document.addEventListener('mouseup', this.onPointerUp)
        document.addEventListener('touchend', this.onPointerUp)
      }
    },
    onPointerMove (e) {
      const point = getEventPoint(e)
      if (!this._dragActivated && (Math.abs(this._downPoint[0] - point[0]) > 2 || Math.abs(this._downPoint[0] - point[0]) > 2)) {
        this._dragActivated = true
        document.body.classList.add('dragging')
      }
      if (this._dragActivated) {
        let left = this._downPosition[0] + (point[0] - this._downPoint[0])
        let top = this._downPosition[1] + (point[1] - this._downPoint[1])
        const overflowDivideFactor = 3
        if (left > this.paneBounds[0]) {
          left = this.paneBounds[0] + (left - this.paneBounds[0]) / overflowDivideFactor
        } else if (this.paneBounds[2] > left) {
          left = this.paneBounds[2] + (left - this.paneBounds[2]) / overflowDivideFactor
        }
        if (top > this.paneBounds[1]) {
          top = this.paneBounds[1] + (top - this.paneBounds[1]) / overflowDivideFactor
        } else if (this.paneBounds[3] > top) {
          top = this.paneBounds[3] + (top - this.paneBounds[3]) / overflowDivideFactor
        }
        cancelAnimationFrame(this._debouncer)
        this._debouncer = requestAnimationFrame(() => {
          this.panePosition = [parseInt(left), parseInt(top)]
        })
      }
      e.preventDefault()
    },
    onPointerUp () {
      if (this._dragActivated) {
        cancelAnimationFrame(this._debouncer)
        this.setPaneOverflowPosition()
        document.body.classList.remove('dragging')
      }
      document.removeEventListener('mousemove', this.onPointerMove)
      document.removeEventListener('touchmove', this.onPointerMove)
      document.removeEventListener('mouseup', this.onPointerUp)
      document.removeEventListener('touchend', this.onPointerUp)
    },
    onPaneScaleChange (scale) {
      if (this.paneScale !== scale) {
        const relatedScale = scale / this.paneScale
        const position = [
          (this.panePosition[0] - this.paneWrapSize[0] * 0.5) * relatedScale + this.paneWrapSize[0] * 0.5,
          (this.panePosition[1] - this.paneWrapSize[1] * 0.5) * relatedScale + this.paneWrapSize[1] * 0.5
        ]
        this.panePosition = position
        this.paneScale = scale
        this.$nextTick(() => {
          this.setPaneOverflowPosition()
        })
      }
    },
    onPaneScaleFit () {
      const pane = this.$refs.pane
      const paneOffsetWidth = pane.offsetWidth
      const paneOffsetHeight = pane.offsetHeight
      const paneHorizontalPadding = this.panePadding[1] + this.panePadding[3]
      const paneVerticalPadding = this.panePadding[0] + this.panePadding[2]
      let paneContentWidth = paneOffsetWidth - paneHorizontalPadding - this.paneExtraPadding[1] - this.paneExtraPadding[3]
      let paneContentHeight = paneOffsetHeight - paneVerticalPadding - this.paneExtraPadding[0] - this.paneExtraPadding[2]
      let scale = Math.min(this.paneWrapSize[0] / paneContentWidth, this.paneWrapSize[1] / paneContentHeight)

      paneContentWidth += paneHorizontalPadding * 1 / scale
      paneContentHeight += paneVerticalPadding * 1 / scale
      scale = Math.max(0.25, Math.min(this.paneWrapSize[0] / paneContentWidth, this.paneWrapSize[1] / paneContentHeight))

      const scaledWidth = paneOffsetWidth * scale
      const scaledHeight = paneOffsetHeight * scale
      this.paneScale = scale

      this.$nextTick(() => {
        this.setPaneOverflowPosition()
        this.panePosition = [
          -(scaledWidth - this.paneWrapSize[0]) / 2 + (52 / 4 * 1 / scale),
          Math.max(this.paneBounds[1], -(scaledHeight - this.paneWrapSize[1]) / 2)
        ]
        this.setPaneOverflowPosition()
      })
    },
    getPaneWrapSize () {
      const paneWrap = this.$refs.paneWrap
      if (paneWrap) {
        this.paneWrapSize = [paneWrap.offsetWidth, paneWrap.offsetHeight]
      }
    },
    setPaneMinPosition () {
      const pane = this.$refs.pane
      if (pane) {
        const [ paneWrapWidth, paneWrapHeight ] = this.paneWrapSize
        const paneWidth = pane.offsetWidth * this.paneScale
        const paneHeight = pane.offsetHeight * this.paneScale
        this.paneBounds = [
          Math.max(0, (paneWrapWidth - paneWidth) / 2),
          Math.max(0, (paneWrapHeight - paneHeight) / 2),
          paneWrapWidth - paneWidth,
          paneWrapHeight - paneHeight
        ]
        this.paneVisibleWidth = pane.offsetWidth
        this.paneBounds[0] = Math.max((paneWrapWidth - paneWidth) / 2, this.paneBounds[0] - this.paneExtraPadding[3] * this.paneScale)
        this.paneBounds[1] = Math.max((paneWrapHeight - paneHeight) / 2, this.paneBounds[1] - this.paneExtraPadding[0] * this.paneScale)
        this.paneBounds[2] += this.paneExtraPadding[1] * this.paneScale
        this.paneBounds[3] += this.paneExtraPadding[2] * this.paneScale
        this.paneBounds[2] = Math.min(this.paneBounds[0], this.paneBounds[2])
        this.paneBounds[3] = Math.min(this.paneBounds[1], this.paneBounds[3])
      }
    },
    setPaneOverflowPosition (withoutTransition) {
      this.setPaneMinPosition()
      const [ paneX, paneY ] = this.panePosition
      const [ minX, minY, maxX, maxY ] = this.paneBounds
      let x = paneX > minX ? minX : maxX > paneX ? maxX : paneX
      if (this.aiReportData && this.aiReportData.direction === 'backward') {
        x = maxX
      }
      const y = paneY > minY ? minY : maxY > paneY ? maxY : paneY
      if (withoutTransition) {
        this.setPanePositionWithoutTransition(x, y)
      } else {
        this.panePosition = [x, y]
      }
    },
    setPanePosition (x, y) {
      this.panePosition = [x, y]
      this.setPaneOverflowPosition()
    },
    setPanePositionWithoutTransition (x, y) {
      const paneWrap = this.$refs.paneWrap
      if (paneWrap) {
        clearTimeout(this._restoreTransitionTimer)
        paneWrap.parentNode.classList.add('no-transition')
        this.panePosition = [x, y]
        this._restoreTransitionTimer = setTimeout(() => {
          paneWrap.parentNode.classList.remove('no-transition')
        }, 10)
      }
    },

    onBlockerClick (e) {
      if (this.reportShowing) {
        this.hideReport()
      }
    },
    setBlocker (value) {
      this.paneBlocked = value
    },

    onNodeListResize () {
      this.setPaneOverflowPosition()
    },
    onResize () {
      if (this.$refs.paneWrap) {
        this.getPaneWrapSize()
        this.$nextTick(() => {
          this.setPaneOverflowPosition(true)
          this.setPanePositionWithoutTransition.apply(null, this.panePosition)
        })
      }
    },
    showTrackingLayer (sequenceIndex, nodeIndex) {
      const nodeData = this.nodesDataArray[sequenceIndex][nodeIndex]
      const nodeInfo = this.nodesData.nodeMap[nodeData._id] || {}

      this.trackingNodeData = {
        ...nodeData,
        ...nodeInfo,
        ...(this.trackingData && { trackingData: this.trackingData }),
        isTargeting: true,
        targetNodeRedisKey: this.nodesDataArray[0][0].redisKey,
        lookupOption: this.lookupOption,
        targetNodeId: this.dataOption.targetNodeId
      }
      this.trackingLayerShowing = true
    },
    setTracking (data) {
      this.trackingData = data
      this.trackingLayerShowing = false
      this.loadPaneData()
    },
    async stopTracking () {
      const confirmed = await openDialog({
        dialogType: 'tracking.stopTracking',
        optionContent: { style: 'height: 32px;' }
      })

      if (!confirmed) return
      this.trackingData = null
      this.trackingNodeData = null
      this.loadPaneData()
    }
  }
}

function getEventPoint (e) {
  if (e.touches) {
    e = e.touches[0] || e.changedTouches[0]
  }
  return [e.pageX || e.clientX, e.pageY || e.clientY]
}

function getParentNodeIndex (targetArray, fromInfo) {
  const nodeId = isNaN(fromInfo.node) ? fromInfo.node : parseInt(fromInfo.node)
  const nodeHash = fromInfo.from_hash
  for (let i = 0, numArray = targetArray.length; i < numArray; i++) {
    if (nodeHash) {
      if (targetArray[i]._hash === nodeHash) {
        return i
      }
    } else if (targetArray[i]._id === nodeId) {
      return i
    }
  }
  return -1
}

function sortByHigherSessCnt (a, b) {
  return b.sessCnt - a.sessCnt
}

function sumPrevNodesHeight (nodesArray, fromIndex) {
  let sum = 0
  const initIndex = nodesArray[fromIndex]._hash === '' ? fromIndex - 2 : fromIndex - 1
  // if (nodesArray[fromIndex]._hash === '') {
  //   return 1
  // }
  for (let nodeIndex = initIndex; nodeIndex >= 0; nodeIndex--) {
    sum += nodesArray[nodeIndex]._height
  }
  return nodesArray[fromIndex]._hash === '' ? sum + 1 : sum
}

function sortByValue (a, b) {
  return a - b
}

function getThumbnailPath (data, device) {
  let path = null
  if (data.imagePath) {
    const { imagePath } = data
    path = imagePath[device] || imagePath.desktop || imagePath.phone || imagePath.tablet
  }
  return path
}
</script>

<style lang="scss">
body.dragging {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
</style>
<style lang="scss" scoped>
.ba-targeting {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  $sequence-header-height: 32px;
  $grid-start-x: calc(var(--targeting-content-start-x) + 425px + 164px);

  .sequence-header,
  .sequence-header .sequence-numbers .number span,
  .pane,
  & /deep/ .ba-targeting-list,
  & /deep/ .more-button-wrap {
    transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  }

  &.node-reporting {
    .sequence-header,
    .sequence-header .sequence-numbers .number span,
    .pane,
    & /deep/ .ba-targeting-list,
    & /deep/ .more-button-wrap {
      transition-timing-function: ease;
    }
  }

  &.no-transition,
  body.dragging & {
    .sequence-header,
    .sequence-header .sequence-numbers .number span,
    .pane,
    & /deep/ .more-button-wrap {
      transition: none;
    }
  }

  &.connection-strength-changing *,
  &.connection-strength-changing {
    .pane,
    & /deep/ .ba-targeting-node,
    & /deep/ .targeting-paths,
    & /deep/ .targeting-paths path,
    & /deep/ .cover {
      transition: none !important;
    }
  }

  .sequence-header-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: $sequence-header-height;
    background: linear-gradient(to right, #242E1A, #242E1A 50%, #8DA50A 50%);
    box-shadow: 0 5px 9px rgba(0, 0, 0, 0.24);
    overflow: hidden;
    z-index: 10;

    &:after {
      position: absolute;
      left: -10px;
      right: -10px;
      top: 0;
      height: calc(100% + 5px);
      content: '';
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.18) 1px, transparent 1px);
      background-position: 0 -1px;
      background-size: 100% 32px;
      box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
      pointer-events: none;
    }

    &.no-data {
      .sequence-header {
        background: #3c3f43 !important;
        &:before {
          content: none;
        }
        .sequence-numbers {
          background: #3c3f43 !important;
        }
      }
    }
  }

  .sequence-header {
    position: absolute;
    left: 0;
    top: calc(#{ $sequence-header-height } * -2 + #{ $sequence-header-height } / 2);
    width: 100%;
    height: calc(#{ $sequence-header-height } * 4);
    background: inherit;
    transform-origin: 0 50%;

    &:before {
      position: absolute;
      left: $grid-start-x;
      top: 0;
      bottom: 0;
      width: var(--targeting-grid-box-width);
      content: '';
      background-image: linear-gradient(to right, rgba(0, 38, 79, 0.2) var(--targeting-grid-line-width), transparent var(--targeting-grid-line-width));
      background-size: var(--targeting-grid-width) 100%;
      z-index: 1;
      pointer-events: none;
    }

    .sequence-numbers {
      position: absolute;
      left: calc(#{ $grid-start-x } - 425px);
      height: 100%;
      padding-left: 425px;
      background: linear-gradient(to right, #242e1a, #597a11 47%, #8da50a 100%);
      display: flex;

      .number {
        position: relative;
        width: var(--targeting-grid-width);
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        letter-spacing: -0.1em;
        line-height: calc(#{ $sequence-header-height } * 4 + 2px);
        text-align: center;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
        overflow: hidden;

        &:before {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          content: '';
          background-color: rgba(200, 255, 0, 0.5);
          opacity: 0;
          transform: translateX(var(--targeting-grid-line-width));
          transition: opacity 0.2s;
        }

        &.focused {
          &:before {
            opacity: 1;
          }
        }

        span {
          position: relative;
          display: block;

          &:before {
            content: '+ ';
          }
        }
      }
    }
  }

  &.backward {
    .sequence-header {
      background: linear-gradient(to left, #08294F, #08294F 50%, #4DB3D8 50%);

      &:before {
        left: auto;
        right: $grid-start-x;
        background-position: calc(100% - var(--targeting-grid-line-width)) 0;
      }

      .sequence-numbers {
        left: auto;
        right: calc(#{ $grid-start-x } - 425px);
        padding-left: 0;
        padding-right: 425px;
        background: linear-gradient(to left, #08294F, #195eab 47%, #4DB3D8 100%);
        flex-direction: row-reverse;

        .number {
          background-color: rgba(113, 209, 255, 0);

          &:before {
            background-color: rgba(113, 209, 255, 0.45);
            transform: translateX(calc(var(--targeting-grid-line-width) * -1));
          }

          span:before {
            content: '- ';
          }
        }
      }
    }

    .pane {
      &:before {
        left: auto;
        right: $grid-start-x;
        background-position: calc(100% - var(--targeting-grid-line-width)) 0;
      }
      &.no-data:before {
        background-position: calc(100% + var(--targeting-grid-width) - 1px) 0;
      }
    }
  }

  .ba-targeting-control {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 52px;
    height: 100%;
  }

  .pane-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #E2E2E0;
    overflow: hidden;
    cursor: -webkit-grab;
    cursor: grab;
    touch-action: none;

    .pane-dimmed {
      background-color: rgba(0,0,0,0.6);
      transition: opacity 0.3s ease;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
    }

    body.dragging & {
      user-select: none;
      pointer-events: none;
    }
  }

  .pane {
    position: relative;
    left: 0;
    top: 0;
    min-width: 100%;
    min-height: 100%;
    background-color: #E2E2E0;
    display: inline-block;
    transform-origin: 0 0;
    will-change: transform;

    &.no-data {
      &:before {
        background-repeat: repeat-y;
      }
    }

    // &:before {
    //   position: absolute;
    //   left: $grid-start-x;
    //   top: 0;
    //   bottom: 0;
    //   width: var(--targeting-grid-box-width);
    //   content: '';
    //   background-image: linear-gradient(to right, rgba(0, 0, 0, 0.1) var(--targeting-grid-line-width), transparent var(--targeting-grid-line-width));
    //   background-size: var(--targeting-grid-width) 100%;
    //   z-index: 1;
    //   pointer-events: none;
    // }
  }

  .pane-button {
    position: absolute;
    right: 20px;
    top: calc(#{ $sequence-header-height } + 20px);
    display: flex;
    gap: 8px;

    > button {
      position: relative;
      height: 34px;
      font-size: 13px;
      color: #444;
      line-height: 34px;
      padding: 0 15px 0 37px;
      border-radius: 20px;
      background-color: #fff;
      box-shadow: 0 17px 14px -5px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.22), 0 1px 3px 0 rgba(0, 0, 0, 0.06);
      overflow: hidden;
      & * {
        transition: all 0.15s ease-out;
      }

      .icon {
        position: absolute;
        left: 11px;
        top: 9px;
      }

      &:before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        content: '';
        background-color: rgba(0, 0, 0, 0.06);
        opacity: 0;
      }

      &:hover:before {
        opacity: 1;
      }
    }
  }

  .blocker {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 9;
  }

  .node-report {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: 444px;
    height: 100%;
    box-shadow: 0 2px 20px -2px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    transition: transform 0.5s ease;

    &.node-report-enter,
    &.node-report-leave-to {
      transform: translate(110%, 0);
    }

    .ba-node-report,
    .ba-node-report-etc {
      overflow: auto;
      height: 100%;
      position: relative;
      z-index: 3;
    }

    .close-report {
      position: absolute;
      z-index: 3;
      top: 50%;
      left: -30px;
      width: 30px;
      height: 70px;
      text-indent: -999em;
      transform: translateY(-50%);
      background: url('../../assets/img/targeting/icon--close-report-button.svg') no-repeat;
      background-position: -5px 50%;
      overflow: hidden;
    }
  }

  .reliability {
    position: absolute;
    z-index: 9;
    bottom: 43.5px;
    right: 25px;
    vertical-align: middle;
    height: 28px;
    border-radius: 5px;

    &.fade-enter-active,
    &.fade-leave-active {
      opacity: 1;
      transition: opacity 0.3s ease;
    }
    &.fade-enter,
    &.fade-leave-to{
      opacity: 0;
    }

    i {
      margin: 4px 0 0 5px;
      float:left;
    }

    span {
      color: #767676;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 28px;
      padding: 0 0px 0 5px;
      vertical-align: middle;
    }
  }

  .pane-base-info {
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    z-index: 8;

    color: #2f2f2f;
    font-weight: 400;
    font-size: 12px;
    line-height: 1;
    &.fade-leave-active,
    &.fade-enter-active {
      transition: opacity 0.5s ease;
      opacity: 1;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }

    .sampling-reliability {
      display: flex;
      align-items: center;
      gap: 5px;
      .icon-wrap {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #FFB427;
        box-sizing: border-box;
      }
    }
    .pane-date {
      padding-left: 25px;
    }
  }

  .grouping-pane {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 11;

    &.grouping-leave-active,
    &.grouping-enter-active {
      transition: right 0.5s ease;
      right: 20px;
    }

    &.grouping-enter,
    &.grouping-leave-to {
      right: -250px;
    }
  }

  .partially-loading {
    &.fade-leave-active,
    &.fade-enter-active {
      transition: opacity 0.3s ease;
      opacity: 1;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }
  }
}
.test-api-wrapper {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 100;
  padding: 10px;
  .test-api-btn {
    cursor: pointer;
    text-align: center;
    padding: 4px 8px;
    margin: 5px;
    background-color: #fff;
  }
}
</style>
